import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const MemberActiveFilter = ({
  filterValue,
  updateFilters,
  disabled = false,
}) => {
  return (
    <FormControl fullWidth={true} variant="outlined" size="small">
      <InputLabel id="disbanded">Member Status</InputLabel>
      <Select
        labelId="select-label"
        id="select"
        disabled={disabled}
        fullWidth={true}
        value={filterValue}
        label="Member Status"
        onChange={(event) => updateFilters(event.target.value)}
      >
        <MenuItem key={'active'} value={'active'}>
          {'Active'}
        </MenuItem>
        <MenuItem key={'inactive'} value={'inactive'}>
          {'Inactive'}
        </MenuItem>
        <MenuItem key={'both'} value={'both'}>
          {'Both'}
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default MemberActiveFilter;
